import { createActionName } from "../../../utility"

export const reducerName = "messages"

export const MESSAGE = createActionName(reducerName, "MESSAGE")
